/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthorizationLeadWaitlistDetails
 */
export interface PalAuthorizationLeadWaitlistDetails {
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistDetails
     */
    status_set_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistDetails
     */
    status_set_reason?: string;
}

/**
 * Check if a given object implements the PalAuthorizationLeadWaitlistDetails interface.
 */
export function instanceOfPalAuthorizationLeadWaitlistDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthorizationLeadWaitlistDetailsFromJSON(json: any): PalAuthorizationLeadWaitlistDetails {
    return PalAuthorizationLeadWaitlistDetailsFromJSONTyped(json, false);
}

export function PalAuthorizationLeadWaitlistDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthorizationLeadWaitlistDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status_set_date': !exists(json, 'status_set_date') ? undefined : json['status_set_date'],
        'status_set_reason': !exists(json, 'status_set_reason') ? undefined : json['status_set_reason'],
    };
}

export function PalAuthorizationLeadWaitlistDetailsToJSON(value?: PalAuthorizationLeadWaitlistDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status_set_date': value.status_set_date,
        'status_set_reason': value.status_set_reason,
    };
}

